module.exports.API_ROOT =
  process.env.NODE_ENV === "development"
    ? "http://localhost:3100"
    : "https://p-api.police.gov.mn";
